// =====================================================================
// PLENARIUM - Faltas e justificativas da sessao (admin) (PLENARIUM:JUSTIFICATIVA)
// Na tela da sessao: quem faltou, a justificativa enviada pelo vereador
// (com o motivo), e os botoes Aceitar / Recusar. O admin tambem pode lancar
// a justificativa recebida em papel (ja entra como aceita).
// =====================================================================
import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const ST = {
  SEM: ['Sem justificativa', '#b91c1c', '#fee2e2'],
  PENDENTE: ['Em análise', '#b45309', '#fef3c7'],
  ACEITA: ['Falta justificada', '#15803d', '#dcfce7'],
  RECUSADA: ['Recusada', '#b91c1c', '#fee2e2']
};
const nomeDe = (v) => (v ? (v.nomeParlamentar || v.nome) : '');
const erroDe = (e, padrao) => (e && e.response && e.response.data && e.response.data.error) || padrao;

export default function JustificativasSessao({ sessaoId, sessaoStatus }) {
  const [dados, setDados] = useState(null);
  const [lancando, setLancando] = useState(null);
  const [texto, setTexto] = useState('');
  const [ocupado, setOcupado] = useState(false);
  const carregar = useCallback(async () => {
    if (!sessaoId) return;
    try { const r = await axios.get(`/api/justificativas/sessao/${sessaoId}`); setDados(r.data); }
    catch (e) { setDados({ erro: erroDe(e, 'Não foi possível carregar as faltas.') }); }
  }, [sessaoId]);
  useEffect(() => { carregar(); }, [carregar, sessaoStatus]);

  if (!sessaoId || (sessaoStatus !== 'ENCERRADA' && sessaoStatus !== 'EM_ANDAMENTO')) return null;
  const decidir = async (j, status) => {
    let observacao = '';
    if (status === 'RECUSADA') { observacao = window.prompt('Motivo da recusa (aparece para o vereador):', '') ; if (observacao === null) return; }
    setOcupado(true);
    try { await axios.patch(`/api/justificativas/${j.id}/decidir`, { status, observacao }); toast.success(status === 'ACEITA' ? 'Falta justificada.' : 'Justificativa recusada.'); await carregar(); }
    catch (e) { toast.error(erroDe(e, 'Não foi possível registrar a decisão.')); }
    finally { setOcupado(false); }
  };
  const lancar = async (v) => {
    if (texto.trim().length < 5) { toast.error('Escreva o motivo (mínimo 5 letras).'); return; }
    setOcupado(true);
    try { await axios.post('/api/justificativas', { sessaoId, vereadorId: v.id, motivo: texto.trim() }); toast.success('Justificativa lançada e aceita.'); setLancando(null); setTexto(''); await carregar(); }
    catch (e) { toast.error(erroDe(e, 'Não foi possível lançar a justificativa.')); }
    finally { setOcupado(false); }
  };
  const excluir = async (j) => {
    if (!window.confirm('Excluir esta justificativa? A falta volta a ficar sem justificativa.')) return;
    setOcupado(true);
    try { await axios.delete(`/api/justificativas/${j.id}`); toast.success('Justificativa excluída.'); await carregar(); }
    catch (e) { toast.error(erroDe(e, 'Não foi possível excluir.')); }
    finally { setOcupado(false); }
  };
  const ausentes = (dados && dados.ausentes) || [];
  const pendentes = ausentes.filter(a => a.justificativa && a.justificativa.status === 'PENDENTE').length;
  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: 800, flex: 1 }}>Faltas e justificativas</h3>
        {pendentes > 0 && <span style={{ background: '#fef3c7', color: '#b45309', fontWeight: 800, fontSize: '.78rem', padding: '3px 10px', borderRadius: 999 }}>{pendentes} em análise</span>}
        <button type="button" className="btn btn-secondary btn-sm" onClick={carregar} disabled={ocupado}>Atualizar</button>
      </div>
      {!dados ? <div style={{ color: '#64748b' }}>Carregando…</div>
        : dados.erro ? <div style={{ color: '#b91c1c' }}>{dados.erro}</div>
        : !ausentes.length ? <div style={{ color: '#15803d', fontWeight: 600 }}>Nenhuma falta nesta sessão.</div>
        : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {sessaoStatus === 'EM_ANDAMENTO' && <div style={{ color: '#64748b', fontSize: '.82rem' }}>Sessão em andamento: a lista de faltas ainda pode mudar. O vereador só consegue justificar depois do encerramento.</div>}
            {ausentes.map(({ vereador: v, justificativa: j }) => {
              const st = ST[j ? j.status : 'SEM'];
              return (
                <div key={v.id} style={{ border: '1px solid #e2e8f0', borderRadius: 10, padding: '10px 12px', background: j && j.status === 'PENDENTE' ? '#fffbeb' : '#fff' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                    <span style={{ width: 34, height: 42, borderRadius: 6, overflow: 'hidden', background: '#e2e8f0', flexShrink: 0 }}>{v.fotoUrl ? <img src={v.fotoUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }} /> : null}</span>
                    <b style={{ flex: 1, minWidth: 140 }}>{nomeDe(v)}{v.partido ? <span style={{ color: '#64748b', fontWeight: 400 }}> · {v.partido}</span> : null}</b>
                    <span style={{ background: st[2], color: st[1], fontWeight: 800, fontSize: '.75rem', padding: '3px 10px', borderRadius: 999 }}>{st[0]}</span>
                  </div>
                  {j && (
                    <div style={{ marginTop: 8, fontSize: '.9rem', color: '#334155' }}>
                      <div style={{ whiteSpace: 'pre-wrap' }}><b>Motivo:</b> {j.motivo}</div>
                      <div style={{ color: '#64748b', fontSize: '.8rem', marginTop: 2 }}>
                        {j.origem === 'ADMIN' ? 'Lançada pela administração' : 'Enviada pelo vereador'} em {new Date(j.criadoEm).toLocaleString('pt-BR')}
                        {j.decididoPor && j.status !== 'PENDENTE' ? ` · ${j.status === 'ACEITA' ? 'aceita' : 'recusada'} por ${j.decididoPor}` : ''}
                        {j.decisaoObs ? ` · Obs.: ${j.decisaoObs}` : ''}
                      </div>
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
                    {j && j.status === 'PENDENTE' && <>
                      <button type="button" className="btn btn-primary btn-sm" style={{ background: '#16a34a', borderColor: '#16a34a' }} disabled={ocupado} onClick={() => decidir(j, 'ACEITA')}>Aceitar</button>
                      <button type="button" className="btn btn-danger btn-sm" disabled={ocupado} onClick={() => decidir(j, 'RECUSADA')}>Recusar</button>
                    </>}
                    {j && j.status !== 'PENDENTE' && <button type="button" className="btn btn-secondary btn-sm" disabled={ocupado} onClick={() => decidir(j, j.status === 'ACEITA' ? 'RECUSADA' : 'ACEITA')}>{j.status === 'ACEITA' ? 'Mudar para recusada' : 'Mudar para aceita'}</button>}
                    {(!j || j.status === 'RECUSADA') && lancando !== v.id && <button type="button" className="btn btn-secondary btn-sm" disabled={ocupado} onClick={() => { setLancando(v.id); setTexto(''); }}>Lançar justificativa</button>}
                    {j && <button type="button" className="btn btn-secondary btn-sm" disabled={ocupado} onClick={() => excluir(j)}>Excluir</button>}
                  </div>
                  {lancando === v.id && (
                    <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
                      <textarea className="form-input" rows={3} maxLength={2000} value={texto} onChange={e => setTexto(e.target.value)} placeholder="Motivo informado (ofício, atestado entregue na Secretaria…)" />
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => setLancando(null)} disabled={ocupado}>Cancelar</button>
                        <button type="button" className="btn btn-primary btn-sm" onClick={() => lancar(v)} disabled={ocupado}>Lançar como falta justificada</button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
    </div>
  );
}
